// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2UuZ1","footer":"Form_footer__2zmGD"};